import type { DocumentActionContext } from '@quipex/shared/contracts';
export function selectedSourceContext(
    context: DocumentActionContext,
    selection: ReadonlyMap<string, ReadonlySet<string>>
): DocumentActionContext {
    const selected = context.sourceSets
        .map((set) => ({
            ...set,
            documents: set.documents.filter((document) =>
                selection.get(set.sourceSetId)?.has(document.documentId)
            ),
        }))
        .filter((set) => set.documents.length);
    const relevant = selected.length ? selected : context.sourceSets.slice(-1);
    return {
        enabled: true,
        ...(selected.length
            ? {
                  selectedDocumentIds: [
                      ...new Set(
                          selected.flatMap((set) =>
                              set.documents.map(
                                  (document) => document.documentId
                              )
                          )
                      ),
                  ],
              }
            : {}),
        sourceSets: relevant.map((set) => ({
            ...set,
            documents: [
                ...new Map(
                    set.documents.map(
                        (document) => [document.documentId, document] as const
                    )
                ).values(),
            ],
        })),
    };
}
